//#region src/errors/payload-too-large.ts
var e = class extends Error {
	constructor() {
		super(), this.name = this.constructor.name;
	}
};
//#endregion
export { e as PayloadTooLarge };
